import { apiBaseURL } from '../ProjectConstants';

/*
 =-=-=-=-=- data structure -=-=-=-=-=
    orderId: int
*/
async function handlePostApproveOrder(orderId, fetch) {

    const response = await fetch.post(`${apiBaseURL}/api/Approval/Approve?orderId=${orderId}`);
    const isDataGood = (response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model');

    console.log('handlePostApproveOrder body', orderId);
    console.log('handlePostApproveOrder response', response);

    return {
        response,
        isDataGood
    };
}
export default handlePostApproveOrder;